<template>
  <div class="detail">
    <!-- banner -->
    <banner :content="content" title="服务体系" type="6"/>
    <div v-if="width >= 1200" class="body">
      <!-- 导航栏 -->
<!--      <div class="nav">-->
<!--        <span style="cursor: pointer;font-size: 24px;" @click="$router.push('/goin')"></span> <i class="el-icon-arrow-right"></i> <span style="margin-right: 10px;display: inline-block;font-size: 24px">{{ toptitle }}</span> <i-->
<!--          class="el-icon-arrow-right"></i> <span style="color:#3DCDD0">详情</span>-->
<!--      </div>-->
      <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-top: 10px">
        <el-breadcrumb-item :to="{ path: '/goin' }"><span style="font-size: 24px;font-weight: normal">天网--心理健康智慧云平台建设</span></el-breadcrumb-item>
        <el-breadcrumb-item><span style="font-size: 24px">{{ toptitle }}</span></el-breadcrumb-item>
        <el-breadcrumb-item><span style="color:#3DCDD0;line-height: 30px;font-size: 24px">详情</span></el-breadcrumb-item>
      </el-breadcrumb>
      <div class=" ql-editor ql-container ql-snow" style=" width: 1440px;margin: 0 auto;">
        <div v-html="content"></div>
      </div>
    </div>
    <div v-if="width <= 768">
      <div>{{title}}</div>

    </div>
    <div>
      <!-- <p>创新“体系化、定制化”的模式——全民普惠，互动共创；构建“数字化、智能化”的平台——科技赋能，融通共享；聚合“专业化、协同化”的资源——链条凝聚、协力共赢。心科技创造心生活，心产业开启心未来！。</p>
      <div class="bigimg">
          <img src="../assets/img/beier.png" alt="">
      </div> -->
      <div v-if="width <= 768" class=" ql-editor ql-container ql-snow" style="width: 100%;">
        <div class="content" style="margin-bottom:50px;">
          <p style="white-space:pre;" class="ql-editor ql-container ql-snow" v-html="content"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import {getArticle} from '../api/api'

export default {
    components: {
        Banner
    },
    data () {
        return {
            content:'',
            title:"",
            createTime:"",
            toptitle:"",
          width: document.body.clientWidth
        }
    },
  watch: {
    width(val) {
      console.log('实时屏幕宽度：', val, this.width)
    }
  },
    mounted () {
      //   let that = this
      // window.addEventListener("resize", function (e) {
      //   that.width = e.target.document.documentElement.clientWidth
      // });
        this.toptitle = this.$route.query.title
        getArticle(this.$route.query.id).then(res => {
            this.content = res.data.data.content
            this.title = res.data.data.title
            this.createTime = res.data.data.createTime
        })
    }
}
</script>

<style lang="scss" scoped>
@import url('../assets/font/font.css');

* {
  margin: 0;
  padding: 0;
  font-family: Microsoft YaHei;
  font-size: 16px;
}

@media (min-width: 1200px) {
  .detail {
    width: 100%;
    height: 100%;
  }
  .body {
    width: 1440px;
    margin: 0 auto;
    box-sizing: border-box;

    .nav {
      width: 100%;
      box-sizing: border-box;
      padding: 30px 0;
      font-size: 24px;
      color: #909090;
      .span{

      }
    }

    .title {
      font-size: 24px;
      color: #000000;
      // text-align:center;
      margin: 30px 0;
    }

    P {
      font-size: 14px;
      color: #000000;
      // margin: 20px 0;
    }

    .bigimg {
      width: 100%;
      height: 596px;
      // display: flex;
      // flex-direction: column;
      // align-items: center;
      margin-bottom: 50px;
      box-sizing: border-box;
      padding: 40px 150px;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

@media (max-width: 768px) {


  ::v-deep .content {
    p {
      img {
        width: 100% !important;
        height: 200px !important;
      }
    }

  }


  ::v-deep .content {
    p {
      img {
        width: 100% !important;
      }
    }

  }
}
</style>
